import { Color } from '../../../odie';

import { DynamicNumber, importDynamicNumber } from '../../../lib/defs/types';
import { pixiColorFromHex } from '../../../lib/pixi/pixiTools';
import { TweenFunction, tweenLinear } from '../../../lib/util/tweens';
import { Particle } from '../Particle';
import { IBehavior } from './IBehavior';

// types
//-----------------------------------------------------------------------------
export type TintBehaviorOptions = {
  type: 'tint';
  from?: DynamicNumber;
  to: DynamicNumber;
  tween?: TweenFunction;
};

/*
    tween tint
*/
export class TintBehavior implements IBehavior {
  // fields
  //-------------------------------------------------------------------------
  private _particle: Particle;
  private _from: Color;
  private _to: Color;
  private _tween: TweenFunction;

  // init
  //-------------------------------------------------------------------------
  constructor(particle: Particle, options: TintBehaviorOptions) {
    this._particle = particle;
    this._from = pixiColorFromHex(
      importDynamicNumber(options.from || 0xffffff),
    );
    this._to = pixiColorFromHex(importDynamicNumber(options.to));
    this._tween = options.tween || tweenLinear;
  }

  // impl
  //-------------------------------------------------------------------------
  public step(dt: number) {
    // get tween value
    const tween = this._tween(this._particle.getTweenTime());

    // lerp color
    const color = this._from.clone().lerpHSL(this._to, tween);

    // commit tint
    this._particle.tint = color.getHex();
  }
}
